import React, { useEffect } from "react";
import "./modal.css";

const Modal = ({ isOpen, onClose, children, className, closeIcon = true }) => {
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-content ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
        {closeIcon && (
          <img
            src="/images/white-close.svg"
            onClick={onClose}
            className="cross-icon"
          />
        )}
      </div>
    </div>
  );
};

export default Modal;
